import { showErrorModal } from "./common"

export default function QliroUpdate(callback) {
  var isQliroLoaded = false;
  if (typeof window.q1 === "object") {
    window.q1.lock();
    isQliroLoaded = true;
  }

  var obj = {};
  obj.IsNewsletter = $(".basket_user-choice-hodler #IsNewsletter").is(":checked");
  obj.IsCatalog = $(".basket_user-choice-hodler #IsCatalog").is(":checked");

  $.ajax({
    type: "POST",
    url: "/api/checkout/PrepareQliroCheckout",
    data: JSON.stringify(obj),
    contentType: "application/json",
    success: function (data) {
      if (data) {
        window.q1Ready = function(q1) {
          q1.onCheckoutLoaded(function () {
            //the checkout has been loaded successfully
            $('#divQliroLoadingMessage').hide();
          })
          
          if (data.OrderId !== 0 && !data.ErrorMessage) {
            // if the order id is not 0, then the order has been created. Otherwise, the order is pending a transaction
            q1.onPaymentProcess(
                function onStart() {
                  // Locking the interface to prevent the customer from changing the order
                  // and setting order status to wait for transaction
                  OrderPaymentLock(data.OrderId)
                },
                function onEnd() {
                  // Unlocking the interface to open up for order changes again
                  // and set the order status to allow for initiating a transaction
                  OrderPaymentUnlock(data.OrderId)
                })
          }
        }
        
        if (isQliroLoaded) {
          window.q1.onOrderUpdated(function (order) {
            // function in onOrderUpdated will execute until unlock is called
            if (order.totalPrice == data.TotalPrice) {
              // example of how the order can be verified
              // unlock will enable the user interaction in the checkout
              window.q1.unlock();
            }
          });
        }
        if (data.ErrorMessage) {
          showErrorModal(data.ErrorMessage);
        }
        if (data.RedirectUrl) {
          window.location.href = data.RedirectUrl;
          return;
        }
        if (data.Html && !isQliroLoaded) {
          $(".QliroCheckout").prepend(data.Html);
        }
        else {
          $("#payment-container > h1").html(data.HeaderText);
          $("#payment-container > p").hide();
        }
        if (callback) {
          callback();
        }
      }
    },
    error: function () {
    }
  });
}

function OrderPaymentLock(orderId) {
  $.ajax({
    type: "GET",
    url: "/api/checkout/OrderPaymentLock?orderId=" + orderId,
    async: true,
    success: function (data) {
    
    },
    error: function () {
    }
  });
}

function OrderPaymentUnlock(orderId) {
  $.ajax({
    type: "GET",
    url: "/api/checkout/OrderPaymentUnlock?orderId=" + orderId,
    async: true,
    success: function (data) {
    
    },
    error: function () {
    }
  });
}
